import { v4 as uuid } from 'uuid';

import { assignSafe, SDate } from '@summit/core';
import { DisplaySchema, FilterParameter, SummitIdObject } from '@summit/models';

import { CrudCacheParameters } from './crud-cache-parameters';

export class CrudCacheItem<T> {
  parameters?: CrudCacheParameters;
  data?: T | T[];
  dataId?: string; // unique string updated only when data is updated, avoid reload on same data
  draft?: boolean;

  static CreatingLoadingDefaultItem<T>(
    idString: string | null,
    filters: string | FilterParameter[] | null
  ): CrudCacheItem<T> {
    return new CrudCacheItem({
      parameters: {
        isLoading: true,
        freshnessDate: SDate.new(),
        filterParameters: filters
      } as CrudCacheParameters,
      data: idString ? (Object() as T) : Array<T>(),
      dataId: uuid()
    });
  }
  constructor(jsonData?: Partial<CrudCacheItem<T>>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.parameters) {
        this.parameters = new CrudCacheParameters(jsonData.parameters);
      }
    }
  }

  reduce(arg0: (max: any, wage: any) => void) {
    throw new Error('Method not implemented.');
  }

  ConvertTo<U extends SummitIdObject>(schema: DisplaySchema<U>) {
    if (this.data instanceof Array) {
      this.data = this.data.map((item) => schema.NewObject(item as Partial<U>) as unknown as T);
    }
  }
}
